/**
 * i18n cho popup thông báo cấp bù chứng thư số MISA eSign (PBI #394834)
 */
export default {
	Title: 'Thông báo cấp bù chứng thư số MISA eSign',
	//Đoạn mở đầu — tách segment để render đậm/đỏ theo design (node 1089-314)
	Intro1: 'Theo ',
	Decree: 'Nghị định 23/2025/NĐ-CP',
	Intro2:
		', Chứng thư số (CTS) của mỗi nhà cung cấp chỉ được cấp tối đa ',
	MaxYears: '03 năm',
	Intro3: ' cho mỗi lần cấp. CTS cấp từ MISA ',
	ExpiredNote: 'sẽ hết hiệu lực vào ngày 03/12/2026',
	Intro4: ', do thời gian sử dụng CTS của Quý khách ',
	Bigger: 'lớn hơn 03/12/2026',
	Intro5:
		' nên MISA sẽ cấp bù CTS để đảm bảo quyền lợi của Quý khách (không phát sinh thêm chi phí).',
	Instruction:
		'Vui lòng làm theo các bước dưới đây để sử dụng chứng thư số mới:',
	OldCert: 'CHỨNG THƯ SỐ CŨ',
	NewCert: 'CHỨNG THƯ SỐ MỚI',
	Account: 'Tài khoản',
	Serial: 'Số chứng thư số',
	Validity: 'Hiệu lực',
	Guide: 'Hướng dẫn',
	Close: 'Đóng',
	Continue: 'Tiếp tục',
	SetupConnect: 'Thiết lập kết nối',
	ChangeService: 'Đăng ký thay đổi CTS',
	//Popup thông báo cấp bù CTS thành công (node Figma 1010-13848)
	SuccessTitle: 'Thành công kết nối chứng thư số MISA eSign',
	SuccessInstruction:
		'Vui lòng thực hiện bước lập tờ khai để hoàn tất quá trình cấp bù chứng thư số.',
	Step1NotConfirmedWarning:
		'Quý khách vui lòng truy cập ứng dụng di động MISA eSign để xác thực thông tin chữ ký số được cấp bù trước khi thực hiện thiết lập chữ ký số.',
	Step1: {
		Title: 'Xác nhận thông tin chứng thư số được cấp bù',
		Desc1: 'Truy cập ',
		DescHighlight: 'ứng dụng di động MISA eSign',
		Desc2: ' và làm theo hướng dẫn.',
	},
	Step2: {
		Title: 'Thiết lập kết nối',
		Desc: 'Kết nối tài khoản MISA eSign chứa chứng thư số được cấp mới.',
	},
	Step3: {
		Title: 'Thay đổi thông tin chứng thư số',
		Desc: 'Thay đổi thông tin chứng thư số sử dụng dịch vụ khai thuế và nộp thuế',
	},
	CompenstCertUnverified: 'Vui lòng truy cập ứng dụng di động MISA eSign để xác thực thông tin chứng thư số trước khi thực hiện kết nối.'
};
